import http from '../../../http';
import appConfig from '../../../services/AppConfigService';

export default {

  resolveFormDesc: function (params) {

    let businessAreaId = params.businessAreaId;
    let systemId = params.systemId;
    let systemVersion = params.systemVersion;

    return appConfig.apiUrl() + "/f/ba/" + businessAreaId + "/c/" + systemId + "/" + systemVersion + "/ms/menu/items/load";
  },

  resolveContractMenu: function (params) {

    return http.get(this.resolveFormDesc(params))
      .then(response => {
        return response.data;
      })
  }

  /*,

  resolveModuleFields: function (params) {

    return http.get(this.resolveFormDesc(params))
      .then(response => {
        return response.data.fields;
      })
  },

  resolveModuleDataRows: function (params) {

    let url = this.resolveFormDesc(params);

    return http.get(url + "/rows")
      .then(response => {

        console.log('aqui deverá devolver os dados cadastrados');
        /!*console.log(response.data);
        console.log(response.data.data);
        console.log(response.data.data.fields);*!/
        return response.data.data
      })
  },

  resolveModuleDataRow: function (params, id) {

    let url = this.resolveFormDesc(params)

    return http.get(url + "/rows/" + id)
      .then(response => {
        return response
      })
  },

  formatDataValues: function() {
    return "Teste"
  },

  moduleDataRowSave: function (params, id, payload) {

    let url = this.resolveFormDesc(params)

    url += "/rows"

    if (id) {
      url += "/" + id;
    }

    let dataToSend = {
      data: payload
    };

    return http({
      method: id ? 'put' : 'post',
      url: url,
      data: JSON.stringify(dataToSend)
    }).then(response => {
      return response.data
    })
  },

  resolveSystemVersion: function(businessAreaId, systemId) {

    let url = API_URL + "/" + businessAreaId + "/c/" + systemId + "/current";

    return http.get(url)
      .then(response => {
        return response.data.data
      })
  }*/
}



// WEBPACK FOOTER //
// ./src/components/root/header/HeaderUtils.js